import React, { useState, useCallback } from 'react';
import { connect } from 'react-redux';
import { Button, Input, Tooltip, Tag } from 'antd';
import { SendOutlined } from '@ant-design/icons';
import styles from './styles/tag-input.module.css';
import sharedStyles from './styles/shared-components.module.css';
import { addAnswer } from '@/store/slices/chatbotFlow';
import { useTranslation } from 'react-i18next';

const TagInput = ({ addAnswer, isChatbotVisible, animTransition }) => {
  const { t } = useTranslation();
  const [tags, setTags] = useState([]);
  const [inputValue, setInputValue] = useState('');
  const [errorMessage, setErrorMessage] = useState('');
  const [showError, setShowError] = useState(false);

  const handleClose = useCallback(
    (removedTag) => setTags(tags.filter(tag => tag !== removedTag)),
    [tags]
  );

  const handleInputChange = useCallback((e) => setInputValue(e.target.value), []);

  const handleInputConfirm = useCallback(() => {
    if (inputValue) {
      const splitTags = inputValue.split(',').map(tag => tag.trim()).filter(tag => tag);
      setTags([...tags, ...splitTags.filter(tag => !tags.includes(tag))]);
      setInputValue('');
      setShowError(false);
    } else if (tags.length === 0) {
      setErrorMessage('Please add at least one tag');
      setShowError(true);
    } else {
      addAnswer(tags);
      setTags([]);
      setShowError(false);
    }
  }, [inputValue, tags, addAnswer]);

  return (
    <div className={sharedStyles.wrapper}>
      <div className={`${styles.tagsContainer} ${tags.length === 0 ? styles.hidden : ''}`}>
        {tags.map(tag => (
          <Tag
            key={tag}
            closable
            onClose={() => handleClose(tag)}
          >
            {tag}
          </Tag>
        ))}
      </div>
      <div className={styles.inputContainer}>
        <Input
          variant={"borderless"}
          className={styles.input}
          placeholder={t('typeHere')}
          value={inputValue}
          onChange={handleInputChange}
          onPressEnter={handleInputConfirm}
        />
        <Tooltip
          placement="topRight"
          align={{ offset: [-5, -5] }}
          title={errorMessage}
          open={showError && isChatbotVisible && animTransition}
        >
          <Button
            className={sharedStyles.send_button}
            type="text"
            danger={showError}
            onClick={handleInputConfirm}
            icon={<SendOutlined style={{ fontSize: '24px' }} />}
          />
        </Tooltip>
      </div>
    </div>
  );
};

const mapDispatchToProps = { addAnswer };

const mapStateToProps = state => ({
  isChatbotVisible: state.chatbotVisibility.isVisible,
  animTransition: state.chatbotVisibility.animTransition,
});

export default connect(mapStateToProps, mapDispatchToProps)(TagInput);